import { Image, Text, View } from '@react-pdf/renderer'
import React from 'react'
import Header from './Header'
import TableHeader from './TableHeader'
import SizeItem from './SizeItem'
import TableRow from './TableRow'

const QualityCheck = ({ data, order }) => {

    return (
        <>

            <Header />
            {
                order.job_order_meta.job_order_meta_summaries.map((summary, index) => {

                    return (
                        <View key={index} style={{ marginBottom: "15px" }}>
                            <SizeItem summary={summary} />
                            <TableHeader />
                            <TableRow summary={summary} />
                        </View>
                    )
                })
            }

        </>
    )
}

export default QualityCheck